import { SkeletonRectangle } from '@leagueplatform/genesis-core';
import { LoaderType } from '@leagueplatform/masonry-api';
import type { MasonryEngineNode } from '@leagueplatform/masonry-engine';
import React from 'react';

export type ExtraSmallSkeletonWSNode =
  MasonryEngineNode<LoaderType.EXTRA_SMALL>;

export const ExtraSmallSkeleton = () => <SkeletonRectangle height={96} />;
